import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { getFirstQueryParam } from '@jusbrasil-web/shared-utils-url'
import { GetServerSideProps } from 'next'

import { AuthLayout, EmailValidationAccount } from '../../components'
import { BASE_PATH_B2B, ROUTES } from '../../constants'
import { getBasePath } from '../../utils/base-path'

export interface VerifyEmailSentPageProps {
  email: string
  basePath: string
}

export function VerifyEmailSentPage({ email, basePath }: VerifyEmailSentPageProps) {
  const isB2B = basePath === BASE_PATH_B2B
  return (
    <AuthLayout>
      <EmailValidationAccount email={email} isB2B={isB2B} />
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  const email = getFirstQueryParam(ctx.query.email)
  const pathname = ctx.resolvedUrl?.split('?')[0] ?? ''
  const basePath = getBasePath(pathname)

  if (!email) {
    return {
      redirect: {
        destination: ROUTES.SIGN_UP.BEGIN,
        permanent: false,
      },
    }
  }

  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
      basePath,
      email,
    },
  }
}

export const VerifyEmailSentPageExports = {
  getServerSideProps,
}
